module.exports = " <div class=group_list _v-76608982=\"\"> <div v-for=\"gid of groupMapIndex | search\" class=group @click=select(gid) :class=\"{ active: currentGroup === gid }\" _v-76608982=\"\"> <avatar :src=groupMap[gid].avatar :username=groupMap[gid].name _v-76608982=\"\"></avatar> <span class=name _v-76608982=\"\">{{ groupMap[gid].name }}</span> <i class=\"ext material-icons\" _v-76608982=\"\">{{ groupMap[gid].shielded ? 'notifications_off' : 'notifications_none' }}</i> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-76608982!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/sidebar/GroupList.vue
 ** module id = 354
 ** module chunks = 2
 **/